import React from "react";

const VERIFIED_ORGANIZER_ID = "695e4b230f9cac5de7adaf81";

export const VerifiedBadge = ({
    organizerId,
    size = 16,
    showId = false,
    className = "",
    style = {},
}) => {
    const isVerified =
        typeof organizerId === "string"
            ? organizerId === VERIFIED_ORGANIZER_ID
            : organizerId?._id === VERIFIED_ORGANIZER_ID;

    if (!isVerified) return null;

    return (
        <div
            className={`verified-badge-wrapper ${className}`}
            style={{ display: "inline-flex", alignItems: "center", gap: 6, ...style }}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#af3051" class="bi bi-patch-check-fill" viewBox="0 0 16 16">
                <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708" />
            </svg>

            {showId && (
                <span
                    style={{
                        fontSize: 11,
                        padding: "3px 8px",
                        borderRadius: 999,
                        background: "#f3f4f6",
                        color: "#374151",
                        fontWeight: 500,
                        letterSpacing: "0.3px",
                    }}
                >
                    {VERIFIED_ORGANIZER_ID.slice(-6)}
                </span>
            )}
        </div>
    );
};